


















import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { Tab } from '@/store/models';

@Component({
  name: 'VTab'
})
export default class VTab extends Vue {
  @Prop({ required: true }) tabs?: Tab[];
  @Prop({ required: true }) selectedTab?: Tab;

  get selectedStyle() {
    return `border-bottom: 3px solid ${this.selectedTab?.color}`;
  }

  @Emit('on-selected')
  public onSelected(tab: Tab) {}
}
